import React, { Component } from 'react';




import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import RarityList from './Admin_Rarity_List';
import RarityDetail from './Admin_Rarity_Detail';
import AdminAPI from './AdminAPI';

export default class Admin_Rarity extends Component {


  constructor(props) {
    super(props);
    this.state = {
      rarity: [], // Load this from your backend
      items: [],
      stats: [],
      creatingNewRarity: false,
      selectedRarityId: ""
    }
  }

  componentDidMount = async () => {
    var rarity = await AdminAPI.getRarity();
    // Sort rarity by dropChance in descending order
    rarity.sort((a, b) => b.dropChance - a.dropChance);

    this.setState({ rarity: rarity });
    this.setState({ items: await AdminAPI.getItems() || [] });
    this.setState({ stats: await AdminAPI.getStats() });
  }

  handleSelectRarity = (rarity) => {

    this.setState({
      selectedRarity: rarity,
      creatingNewRarity: false,
      selectedRarityId: rarity.id,
    });

  };

  handleNewRarity = () => {
    this.setState({
      creatingNewRarity: true,
      selectedRarity: {},
      selectedRarityId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedRarity: null,
      creatingNewRarity: false,
    });
  };

  handleUpdate = async (rarity) => {
    const response = await apiPut("/rarity", JSON.stringify(rarity));
    if (response.ok) {
      this.setState({ rarity: await AdminAPI.getRarity() });
      this.setState({ selectedRarityId: null });
    }
  };

  handleDelete = async (rarity) => {
    // Send delete request to your backend
    const response = await apiDelete("/rarity/" + rarity.id);
    if (response.ok) {
      this.setState({ rarity: await AdminAPI.getRarity() });
      this.setState({ selectedRarityId: null });
    }
  };

  handleCreate = async (rarity) => {
    // Send delete request to your backend
    const response = await apiPost("/rarity", JSON.stringify(rarity));

    if (response.ok) {

      this.setState({ rarity: await AdminAPI.getRarity() });
      this.setState({ selectedRarityId: null });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the rarity based on search query
  };



  // findSelectedRarity = () => {

  //   return this.state.rarity.find((c) => c.id === this.state.selectedRarityId);

  // }



  render() {
    const { rarity, creatingNewRarity } = this.state;

    return (
      <div className="admin-settingspage">
        <RarityList
          rarity={rarity}
          onSelectRarity={this.handleSelectRarity}
          onSearch={this.handleSearch}
          onNewRarity={this.handleNewRarity}
        />



        <RarityDetail
          items={this.state.items}
          stats={this.state.stats}
          creatingNewRarity={creatingNewRarity}
          rarityId={this.state.selectedRarityId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
